import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import TablaCalificacion from '../../../../exportacion_react_pdf/TablaCalificacion';
import TextAreaLabelGroup from '../../../../exportacion_react_pdf/TextAreaLabelGroup';

const secciones_capacidades_servicio = [
    {
        key: '1',
        title: '1. PLANIFICACION Y GESTION DEL TIEMPO',
        questions: [
            {
                section: '1.1',
                description: 'El/la productor/a  identifica  variables de planificacion y organizacion para la prestacion de su servcio ? (Periodicidad del servicio, inventarios, gastos, ingresos, proyeccion de ventas, etc)',
            },
            {
                section: '1.2',
                description: 'El productor/a cuenta con un flujo de procesos respecto a la prestacion de su servicio',
            },

        ],
    },
    {
        key: '2',
        title: '2. COSTOS DE SERVICIOS',
        questions: [
            {
                section: '2.1',
                description: 'El/la productor/a identifica las variables o rubros asociados a los costos de producccion para el servicio que presta ',
            }
        ],
    },
    {
        key: '3',
        title: '3. MANTENIMIENTO',
        questions: [
            {
                section: '3.1',
                description: 'El productor/a aplica labores de revision y supervision para el mantenimiento de la maquinaria e insumos con los que actualmente cuenta ',
            },
        ],
    },
    {
        key: '4',
        title: '4. SEGUIRDAD',
        questions: [
            {
                section: '4.1',
                description: 'El/la productor/a implementa prácticas y técnicas para la prevención y/o mitigacion de riesgos que se puedan presentar en la prestacion de su servicio',
            }
        ],
    },

    {
        key: '5',
        title: '5.PROTECCION DE ECOSISTEMAS, SALUD DEL SUELO Y MANEJO DE RESIDUOS',
        questions: [
            {
                section: '5.1',
                description: 'El/la productor/a reconoce la clasificacion de residuos organicos que produce y su manejo?',
            },
            {
                section: '5.2',
                description: 'El /la productor/a reconoce los residuos peligrosos y conoce las practicas para su adecuada disposición?',
            }
        ],
    },


    {
        key: '6',
        title: '6. PRESTACION EL SERVICIO',
        questions: [
            {
                section: '6.1',
                description: 'El productor/a aplica estrategias que le permitan medir la satisfaccion del servicio prestado',
            }

        ],
    },
    {
        key: '7',
        title: '7. SALUD',
        questions: [
            {
                section: '7.1',
                description: 'El productor/a conoce pautas de trabajo tendientes a preservar su seguridad y salud',
            }
        ],
    }
];
// Define el documento
const ExportServicioPaso7 = ({ formData, styles }) => (
    <>
        {/* Sección de Identificació del proyecto */}
        <View style={styles.section}>
            <Text style={styles.title_1}>CAPACIDADES DE SERVICIOS</Text>

            <TablaCalificacion evaluacion={formData?.capacidades_servicios} secciones={secciones_capacidades_servicio}></TablaCalificacion>

            {/* Título principal */}
            <Text style={styles.tag}>
                SEGUNDA PARTE. PROPUESTA PLAN DE ACOMPAÑAMIENTO INTEGRAL BASADO EN MEJORAMIENTO DE INDICADORES
            </Text>

            {/* Título secundario */}
            <Text style={styles.greyTag}>
                SELECCIÓN DE INDICADORES
            </Text>

            {/* Nota para el equipo */}
            <Text style={styles.noteTitle}>
                NOTA PARA EL EQUIPO
            </Text>
            <Text style={styles.noteText}>
                En este punto se deben identificar los aspectos que es posible mejorar en el predio, considerando la realidad del productor,
                condiciones de la finca, recursos, tiempo, etc. Se sugiere seleccionar un máximo de 6 indicadores a mejorar. Los indicadores
                deben seleccionarse de manera conjunta con el productor, quien recibirá acompañamiento y responderá por los procesos y las
                recomendaciones dadas para su cumplimiento.
            </Text>

            <TextAreaLabelGroup
                label='Nombre del indicador'
                selectedValue={formData?.capacidades_servicios?.seleccion_indicador?.nombre_indicador || ''}>
            </TextAreaLabelGroup>
        </View>

    </>
);

export default ExportServicioPaso7;